export const navBackOrHomepage = () => {
  if (
    window.history.length > 2 &&
    (!document.referrer || document.referrer.startsWith(window.location.origin))
  ) {
    if (document.referrer === window.location.origin) {
      window.location.href = '/'
    } else {
      window.history.back()
    }
  } else {
    window.location.href = '/'
  }
}
